import { useEffect, useState } from "react";
import Input from "./form/input";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const ResetPass = () => {

    const { token } = useParams();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    // functions from App component
    // to transit values of JWT and errors to App component
    const { setAlertClassName } = useOutletContext();
    const { setAlertMessage } = useOutletContext();

    const navigate = useNavigate();

    // delete all the previous errors
    useEffect(() => {
        setAlertClassName("d-none"); // hide alert if it was
        setAlertMessage("");
    }, [setAlertClassName, setAlertMessage]);


    const handleSubmit = (event) => {
        event.preventDefault();

        // Validation 
        // check if the fields are not empty
        if (password === "" || confirmPassword === "") {
            setAlertClassName("alert-danger");
            setAlertMessage("All fields must be filled!")
            return
        }

        // check if passwords are similar
        if (password !== confirmPassword) {
            setAlertClassName("alert-danger");
            setAlertMessage("Passwords are not the same!");
            return
        }

        // check if passwords are too long
        if (password.length > 50 || confirmPassword.length > 50) {
            setAlertClassName("alert-danger");
            setAlertMessage("Password is too long!");
            return
        }

        // check if password is too weak
        if (password.length < 3 || confirmPassword.length < 3) {
            setAlertClassName("alert-danger");
            setAlertMessage("Password is extremely weak!");
            return
        }

        //  create the request payload
        let payload = {
            password: password,
            confirm_password: confirmPassword,
            token: token
        }

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            withCredentials: true,
            body: JSON.stringify(payload),
        }

        // make a request
        fetch(`${process.env.REACT_APP_BACKEND}/api/reset-password`, requestOptions)
            // convert response to json 
            .then((response) => response.json())
            .then((data) => {
                // if there IS an error 
                if (data.error) {
                    setAlertClassName("alert-danger"); // show error class
                    setAlertMessage(data.message);
                } else { // if there is NO error
                    setAlertClassName("d-none"); // hide alert if it was
                    setAlertMessage("");
                    Swal.fire({ // message to confirm email
                        title: 'Password has been changed!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                    navigate("/"); // redirect to home page
                }
            })
            // if there is an unexpected error
            .catch(error => {
                setAlertClassName("alert-danger");
                setAlertMessage(error);
            })
    }

    return (
        <div className="col-md-6 offset-md-3">
            <h2>Reset password</h2>
            <hr />
            <form onSubmit={handleSubmit}>
                <Input
                    title="Password"
                    type="password"
                    className="form-control"
                    name="password"
                    autoComplete="password-new"
                    onChange={(event) => setPassword(event.target.value)}
                />
                <Input
                    title="Repeat password"
                    type="password"
                    className="form-control"
                    name="password"
                    autoComplete="password-new"
                    onChange={(event) => setConfirmPassword(event.target.value)}
                />
                <hr />
                <input
                    type="submit"
                    className="btn btn-primary"
                    value="Reset"
                />
            </form>
        </div>
    )
}

export default ResetPass;